var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoCard6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 65,
    viewBox: "0 0 62 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 41V53.5M24.25 41V53.5M19.25 41H41.75C45.2018 41 48 43.7982 48 47.25C48 50.7018 45.2018 53.5 41.75 53.5H19.25C15.7982 53.5 13 50.7018 13 47.25C13 43.7982 15.7982 41 19.25 41Z",
    stroke: "url(#paint0_linear_4132_28566)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 13.5V1M8.5 13.5H53.5C57.6421 13.5 61 16.8579 61 21V56C61 60.1421 57.6421 63.5 53.5 63.5H8.5C4.35786 63.5 1 60.1421 1 56V21C1 16.8579 4.35786 13.5 8.5 13.5Z",
    stroke: "url(#paint1_linear_4132_28566)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 33.25C18.433 33.25 20 31.683 20 29.75C20 27.817 18.433 26.25 16.5 26.25C14.567 26.25 13 27.817 13 29.75C13 31.683 14.567 33.25 16.5 33.25ZM44 33.25C45.933 33.25 47.5 31.683 47.5 29.75C47.5 27.817 45.933 26.25 44 26.25C42.067 26.25 40.5 27.817 40.5 29.75C40.5 31.683 42.067 33.25 44 33.25Z",
    stroke: "url(#paint2_linear_4132_28566)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4132_28566",
    x1: 14.3212,
    y1: 40.6635,
    x2: 21.0033,
    y2: 61.9619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4132_28566",
    x1: 3.26491,
    y1: -0.682696,
    x2: 61.5225,
    y2: 62.9818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4132_28566",
    x1: 15.2268,
    y1: 27.1154,
    x2: 16.4689,
    y2: 36.3055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoCard6);
export default __webpack_public_path__ + "static/media/auto_card6.de900d2df76f36957c0e39eb48de4f82.svg";
export { ForwardRef as ReactComponent };